import { render, staticRenderFns } from "./CostTypesSettings.vue?vue&type=template&id=272e2fd0&"
import script from "./CostTypesSettings.vue?vue&type=script&lang=js&"
export * from "./CostTypesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports